<!-- leftPin -->
<template>
	<div class="leftPin">
		<el-popover placement="left" width="200" trigger="hover">
			<div @mouseover="mouseOver('1')" @mouseleave="mouseLeave('1')" class="flex-column justify-content-center" style="height:100px">
				<div class="flex align-items">
					<img src="@/assets/qqicon.png" alt="" style="width:30px;height:30px;">
					<span style="font-size: 16px; color: #333333; margin-left:15px">{{siteData.qq}}</span>
				</div>
				<div class="flex align-items" style="margin-top:20px;">
					<img src="@/assets/phoneicon.png" alt="" style="width:30px;height:30px;">
					<span style="font-size: 16px; color: #333333; margin-left:15px">{{siteData.hotLine}}</span>
				</div>
			</div>
			<div slot="reference" @mouseover="mouseOver('1')" @mouseleave="mouseLeave('1')" class="leftPin_ever flex-column justify-content-center align-items page-click">
				<img ref="icon1" src="@/assets/lefticon1.png" alt="" style="width: 24px; height: 24px" />
				<div ref="text1" style="font-size:12px;">在线客服</div>
			</div>
		</el-popover>
		<el-popover placement="left" width="300" trigger="hover">
			<div @mouseover="mouseOver('2')" @mouseleave="mouseLeave('2')" class="flex justify-content-space-around" style="height: 120px">
				<div class="flex-column align-items">
					<img :src="$path+siteData.wechat" alt="" style="width: 100px; height: 100px" />
					<span style="font-size: 16px; color: #333333; margin-left: 5px">微信公众号</span>
				</div>
				<div class="flex-column align-items">
					<img :src="$path+siteData.wechatService" alt="" style="width: 100px; height: 100px" />
					<span style="font-size: 16px; color: #333333; margin-left: 5px">微信客服</span>
				</div>
			</div>
			<div @mouseover="mouseOver('2')" @mouseleave="mouseLeave('2')" slot="reference" class="leftPin_ever flex-column justify-content-center align-items page-click">
				<img ref="icon2" src="@/assets/lefticon2.png" alt="" style="width: 24px; height: 24px" />
				<div ref="text2" style="font-size:12px;">关注我们</div>
			</div>
		</el-popover>
		<div @mouseover="mouseOver('3')" @mouseleave="mouseLeave('3')" class="leftPin_ever flex-column justify-content-center align-items page-click" @click="toTop">
			<img ref="icon3" src="@/assets/lefticon3.png" alt="" style="width: 24px; height: 24px" />
			<div ref="text3" style="font-size:12px;">返回顶部</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "leftPin",
		data() {
			return {
				siteData:{},
			};
		},
		created() {
			if (JSON.parse(window.localStorage.getItem("siteData")) == null) {
				this.getCompanyInfo();
			} else {
				this.siteData = JSON.parse(window.localStorage.getItem("siteData"));
			}
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll, true);
		},
		methods: {
			getCompanyInfo() {
				this.$api.iotHome.companyInfo().then((res) => {
					if (res.success == true) {
						window.localStorage.setItem("siteData", JSON.stringify(res.data));
						this.siteData = res.data;
					}
				});
			},
			handleScroll() {
				let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
				scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
			},
			mouseOver(index){
				var obj = {
					'1':{code:'icon1',text:'text1',url:require('@/assets/lefticon1-hover.png')},
					'2':{code:'icon2',text:'text2',url:require('@/assets/lefticon2-hover.png')},
					'3':{code:'icon3',text:'text3',url:require('@/assets/lefticon3-hover.png')},
				}
				this.$refs[obj[index].code].src = obj[index].url;
				this.$refs[obj[index].text].style.color= '#FF6700';
			},
			mouseLeave(index){
				var obj = {
					'1':{code:'icon1',text:'text1',url:require('@/assets/lefticon1.png')},
					'2':{code:'icon2',text:'text2',url:require('@/assets/lefticon2.png')},
					'3':{code:'icon3',text:'text3',url:require('@/assets/lefticon3.png')},
				}
				this.$refs[obj[index].code].src = obj[index].url;
				this.$refs[obj[index].text].style.color= '#999999';
			},
			toTop() {
				let top = document.documentElement.scrollTop || document.body.scrollTop;
				// 实现滚动效果 
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
					if (top <= 0) {
						clearInterval(timeTop);
					}
				}, 1);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.leftPin {
		position: fixed;
		right: 0px;
		width: 80px;
		height: 243px;
		z-index: 999;
		top: 35vh;
		background: #ffffff;
		box-shadow: -3px 0px 6px 0px rgba(55, 52, 52, 0.07);

		.leftPin_ever {
			width: 100%;
			height: 80px;
			&:hover{
				div{
					color:#FF6700;
				}
			}
			div {
				font-size: 12px;
				font-family: Source Han Sans CN, Source Han Sans CN-Regular;
				font-weight: 400;
				color: #999999;
				margin-top: 10px;
			}
		}
	}
</style>
